import path from 'ramda/src/path'

export const isServiceMilestone = (params) =>
  path(['data', 'isService'], params)

export const isCheckpointMilestone = (params) => params?.data?.isCheckpoint
